import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { takeAfterAuth } from "@/components/CouponOfDay";
import { isFreshSignup } from "@/lib/membership";

// Handles the Emergent Google OAuth return: URL fragment #session_id=...
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeGoogle } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate("/login", { replace: true }); return; }

    completeGoogle(sessionId)
      .then((user) => {
        // Clear the fragment so a refresh doesn't reprocess it
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        toast.success(`Benvenuto${user?.name ? ", " + user.name.split(" ")[0] : ""}!`);
        navigate(isFreshSignup(user) ? "/benvenuto" : takeAfterAuth() || "/", { replace: true });
      })
      .catch((e) => {
        setError(e.message || "Accesso con Google non riuscito");
        setTimeout(() => navigate("/login", { replace: true }), 2200);
      });
  }, [location.hash, completeGoogle, navigate]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center gap-4 px-6 text-center">
      {error ? (
        <p className="text-bad text-sm">{error}</p>
      ) : (
        <>
          <Loader2 size={30} className="animate-spin text-brand" />
          <p className="text-subtle text-sm font-mono">Accesso in corso…</p>
        </>
      )}
    </div>
  );
}
